
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from "react";
import { faAddressBook, faIdCard, faPhone, faFile,faBuilding } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Badge , Container, InputGroup } from '@themesberg/react-bootstrap';

import api from "../../api/axios";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import { dashboardUser, updateProfile } from "../../api/services/";
import Preloader from "../../components/Preloader"; // Path to your code above

export default () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [dlNumber, setDlNumber] = useState("");
  const [address, setAddress] = useState("");
  const [isActive, setIsActive] = useState(Boolean);
  const [role, setRole] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);
      try {
        const result = await dashboardUser();
        console.log("Dashboard Data:", result);
        setIsActive(result.isActive);
        setRole(result.role);
        setPhoneNumber(result.phone);
        setPanNumber(result.panNumber);
        setCompanyName(result.companyName);
        setGstNumber(result.gstNumber);
        setDlNumber(result.dlNumber);
        setAddress(result.address);
        setPanNumber(result.panNumber);
        console.log("User Active Status:", result.isActive);
        console.log("User Role:", result.role);
      } catch (error) {
        console.log("Dashboard Data fetch Error:", error.response?.data || error.message);
      }
      finally {
        setShowLoader(false);
      }
    };
    fetchData();
  }, []);

  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowLoader(true);
    setSuccess("");
    setError("");

    try {
      const payload = {
        phone: phoneNumber,
        companyName,
        gstNumber,
        panNumber,
        dlNumber,
        address
      };

      console.log("Form submitted with data:", payload);

      const resp = await updateProfile(payload);

      console.log("Profile update response:", resp);

      setSuccess(resp?.message || "Profile updated successfully!");
    } catch (error) {
      console.log("Form submission error:", error.response?.data || error.message);

      // ✅ Better error handling
      setError(
        // error.response?.data?.message ||
        // error.response?.data?.error ||
        "Something went wrong!"
      );
    } finally {
      setShowLoader(false);
    }
  };


  return (
    <main>
      {/* <Preloader show={showLoader} /> */}
      {isActive ? (
        <Card className="shadow-sm border-0 mt-4 vh-100">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Profile Details</h5>

              <Badge bg={isActive ? "success" : "warning"}>
                {isActive ? "Active" : "Pending"}
              </Badge>
            </div>

            <Row className="g-3">

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faPhone} className="me-2 text-primary" />
                  <strong>Phone:</strong>
                  <div className="text-muted">{phoneNumber || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faBuilding} className="me-2 text-primary" />
                  <strong>Company:</strong>
                  <div className="text-muted">{companyName || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faIdCard} className="me-2 text-primary" />
                  <strong>GST:</strong>
                  <div className="text-muted">{gstNumber || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faIdCard} className="me-2 text-primary" />
                  <strong>PAN:</strong>
                  <div className="text-muted">{panNumber || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faIdCard} className="me-2 text-primary" />
                  <strong>DL Number:</strong>
                  <div className="text-muted">{dlNumber || "-"}</div>
                </div>
              </Col>

              <Col md={12}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faAddressBook} className="me-2 text-primary" />
                  <strong>Address:</strong>
                  <div className="text-muted">{address || "-"}</div>
                </div>
              </Col>

            </Row>
          </Card.Body>
        </Card>
      )
        :
        (
          <Container className="px-0" style={{ backgroundColor: `#ffffff` }}>
            <section className="d-flex align-items-center my-5 mt-lg-2 mb-lg-5" >
              <Container>
                <div className="d-flex justify-content-center align-items-center mt-4">
                </div>
                {error && (<div class="alert alert-danger">
                  {error}
                </div>)}

                {
                  success && (<div class="alert alert-success">
                    {success}
                  </div>)
                }
                <Row className="justify-content-center form-bg-image">
                  <Col lg={12} /*className="d-flex align-items-center justify-content-center"*/>
                    <Form className="mt-4" onSubmit={handleSubmit}>
                      <Form.Group id="phone" className="mb-2">
                        <Form.Label>Phone Number</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faPhone} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="tel"
                            placeholder="Phone Number"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group id="company" className="mb-4">
                        <Form.Label>Company Name</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faFile} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="Company Name"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group id="gst_number" className="mb-4">
                        <Form.Label>GST Number</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faIdCard} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="GST Number"
                            value={gstNumber}
                            onChange={(e) => setGstNumber(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group id="pan_number" className="mb-4">
                        <Form.Label>PAN Number</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faIdCard} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="PAN Number"
                            value={panNumber}
                            onChange={(e) => setPanNumber(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group id="dl_number" className="mb-4">
                        <Form.Label>DL Number</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faIdCard} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="DL Number"
                            value={dlNumber}
                            onChange={(e) => setDlNumber(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group id="address" className="mb-4">
                        <Form.Label>Address</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faAddressBook} />
                          </InputGroup.Text>
                          <Form.Control
                            autoFocus
                            required
                            type="text"
                            placeholder="Address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Button variant="primary" type="submit" className="w-100">
                        Submit for Approval
                      </Button>
                    </Form>
                    <div className="d-flex justify-content-center align-items-center mt-4">
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
          </Container>
        )
      }
    </main>
  );
};
